import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import useInsightsShape from '../../hooks/useInsightsShape';
import { useRecordedSalesInsideShape, useRecordedSalesInStore } from '../../hooks/useRecordedSales';
import { IDetailsTabProps } from '../../interfaces/IDetailsTabProps';
import RecordedSalesGrid from '../RecordedSalesGrid';

function InsightsRecordedSalesTab({ visible, setEntityCount }: IDetailsTabProps) {
    const insightsShape = useInsightsShape();
    const recordedSales = useRecordedSalesInsideShape(insightsShape);
    useRecordedSalesInStore(visible ? recordedSales : []);

    useEffect(() => setEntityCount(recordedSales.length), [recordedSales]);

    if (!visible || !insightsShape)
        return null;

    return (
        <RecordedSalesGrid recordedSales={recordedSales} />
    );
}

export default observer(InsightsRecordedSalesTab);